/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $HandbookCategory = {
    properties: {
        id: {
    type: 'number',
},
        name: {
    type: 'string',
    isRequired: true,
},
        companyId: {
    type: 'number',
    isRequired: true,
},
        createdAt: {
    type: 'string',
},
    },
};